import styled from 'styled-components';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import { colors } from '@material-ui/core';

export const DesktopFilters = styled(Box)`
  ${({ theme: { breakpoints, colors } }) => `
  .Radius {width:100px; 
    background-color: #fff;
    max-width: 50px ;
    width:50px;
  }

    position: relative;
    display: none;
    &:before {
      content: '';
        position: absolute;
        top: 0;
        right: 0 !important;
        background-color:  ${colors.greens.green0} !important;
        right: -16px;
        width: 100vw;
        height: 100%;
        background-color: #fff;
        z-index: -1;
    }

    ${breakpoints.up('lg')} {
      display: block;
    }
  `}
`;

export const StyledMobileFilters = styled(Box)`
  ${({ theme: { breakpoints } }) => `
    position: relative;

    ${breakpoints.up('lg')} {
      display: none;

    }
  `}
`;

export const Container = styled(Grid)`

${({ theme: { breakpoints, colors } }) => `
.MuiGrid-root:nth-child(n + 3) .MuiFormControl-root {
 
  &[aria-controls="popper-open"] {
    .MuiInputBase-input {-webkit-text-fill-color: ${colors.golds.gold1}}
    svg path { fill:${colors.golds.gold1} }
    svg {  transform: rotate(180deg);
      -webkit-transform: rotate(180deg);}
}
`}
}
.radiusFilter {
  input {font-weight: bold !important;}
  ${({ theme: { breakpoints, colors } }) => `
  svg path { fill: #1c1b1f !important }
  border-radius: 0 5px 5px 0 ;
  input.MuiInputBase-input {-webkit-text-fill-color: #003C3B !important; font-weight: normal; font-size:12px !important; }
  background-color: ${colors.whites.white1} !important;
  width: 100px;
  max-width: 100px;
  .MuiInputBase-input {color: #003C3B !important; }
  .MuiInputBase-root { background-color: transparent !important; padding-left:0;}
  height: 38px;
  `}
}


padding: 10px 0;
 
  ${({ theme: { breakpoints, colors } }) => `

svg {   transition-duration: 0.8s !important;
  transition-property: transform !important;}
  svg path { fill:${colors.golds.gold1} !important;}


  &:before {
    content: '';
      position: absolute;
      top: 0;
      left: 0 !important;
      background-color: ${colors.greens.green0} !important;
      left: -16px;
      width: 100vw;
      height: 100%;
      background-color: #fff;
      z-index: -1;
  }


  
    & > div {
    
       :last-child {border: none;}
      margin-right: 2px;
      padding-top:4px;
      border-right: 1px solid #fff;

      &:first-child {
        margin: 0 0 2px;
        padding-top: 0;
      }

      &:last-child {
        margin-right: 0;
      }

      ${breakpoints.up('lg')} {
        &:first-child {
          margin: 0;
        }
      }
    }
  `}
`;
